import React from 'react';
import { Container, Carousel } from 'react-bootstrap';
import '../css/App.css';

function Gallery() {
  
    const images = [
    { src: "/images/Foto6.jpeg",  alt: "Iveco EuroCargo Nucifora Trasporti con cisterna inox per trasporto acqua potabile" },
    { src: "/images/Foto4.jpeg",  alt: "Carico su Iveco EuroCargo Nucifora Trasporti con muletto - servizio trasporto su pallet" },
    { src: "/images/Foto10.jpeg", alt: "Volvo FH Nucifora Trasporti con semirimorchio frigorifero - trasporti refrigerati in Italia" },
    { src: "/images/Foto2.jpeg",  alt: "Autobotte Nucifora Trasporti con cisterna acqua nella campagna siciliana - Etna" },
    { src: "/images/Foto8.jpeg",  alt: "Autobotte Nucifora Trasporti in servizio di consegna acqua a Catania" },
    { src: "/images/Foto9.jpeg",  alt: "Volvo FH Nucifora Trasporti con semirimorchio frigorifero al centro distribuzione BRT" },
    { src: "/images/Foto13.jpeg", alt: "Volvo FH Nucifora Trasporti con semirimorchio frigorifero - trasporti nazionali Sicilia" },
    { src: "/images/Foto14.jpeg", alt: "Volvo FH Nucifora Trasporti con semirimorchio centinato al porto - trasporti nazionali" },
    { src: "/images/Foto15.jpeg", alt: "Nucifora Trasporti trasporto container CMA CGM 20 piedi - servizio container Sicilia" },
    { src: "/images/Foto16.jpeg", alt: "Volvo FH Nucifora Trasporti con container su strada siciliana - provincia di Catania" },
    { src: "/images/Foto17.jpeg", alt: "Volvo FH Nucifora Trasporti con semirimorchio centinato carico di sacchi alla rinfusa" },
    { src: "/images/Foto19.jpeg", alt: "Rifornimento acqua tramite autobotte Nucifora Trasporti - fornitura acqua per villa privata in Sicilia" },
    { src: "/images/Foto20.jpeg", alt: "Iveco EuroCargo Nucifora Trasporti con cassette tra i vigneti dell'Etna - trasporti agricoli" },
    { src: "/images/Foto21.jpeg", alt: "Riempimento piscina privata con autobotte Nucifora Trasporti - servizio acqua Catania" },
    { src: "/images/Foto24.jpeg", alt: "Iveco EuroCargo Nucifora Trasporti con furgonato in un vigneto siciliano" },
    { src: "/images/Foto26.jpeg", alt: "Autobotte Nucifora Trasporti per trasporto liquidi alimentari in cantina vinicola siciliana" },
    { src: "/images/Foto27.jpeg", alt: "Volvo FH Nucifora Trasporti con semirimorchio frigorifero in consegna - distribuzione alimentare" },
    { src: "/images/Foto29.jpeg", alt: "Volvo FH Nucifora Trasporti con semirimorchio frigorifero scarico al centro logistico" },
  ];


  return (
    <div className="w3-container section-gray" id="gallery">
      <h1 className="w3-xxxlarge w3-text-black">
        <b>Galleria</b>
      </h1>
      <p className="w3-large w3-text-amber" style={{ marginTop: '-10px', marginBottom: '20px' }}>
        <i><b>La forza del nostro lavoro, catturata in ogni scatto</b></i>
      </p>
      <hr className="w3-round hr-amber" />

      <Container fluid className="mt-4">
        <Carousel fade interval={3000} className="mt-4">
           {images.map((img, index) => (
             <Carousel.Item key={index}>
                <img
                    className="d-block w-100"
                    src={img.src}
                    alt={img.alt}
                    style={{ width: '100%', maxHeight: '500px', objectFit: 'cover' }}
                />
             </Carousel.Item>
            ))}
        </Carousel>
      </Container>

    </div>
  );
}

export default Gallery;
